import Card from '../../../components/card/Card';
import H from '../../../components/texts/h/H';
import Span from '../../../components/texts/span/Span';
import Badge from '../../../components/badge/Badge';
import { format, parseISO } from 'date-fns';
import { useClientTheme } from '../../../context/ThemeContext';
import { ValidityData } from '../../../types/interfaces';

const LABEL_BADGE_VARIANT: Record<ValidityData['label'], string> = {
  VALID: 'success',
  EXPIRED: 'danger',
  NO_DATA: 'neutral',
};

const LABEL_TEXT_VARIANT: Record<ValidityData['label'], string> = {
  VALID: 'success',
  EXPIRED: 'danger',
  NO_DATA: 'neutral',
};

const LABEL_TEXT: Record<ValidityData['label'], string> = {
  VALID: 'VIGENTE',
  EXPIRED: 'VENCIDA',
  NO_DATA: 'SIN DATOS',
};

const formatDate = (value: string | null): string =>
  value ? format(parseISO(value), 'dd/MM/yyyy') : '—';

/**
 * Read-only "Vigencia" frame of the detail view (Solicitud tab, Task 53633).
 * Rendered only for FIN folders with a validity block (gate in Summary,
 * isFinishedStatus && clientInfo.validity != null). The front NEVER recomputes
 * against the browser date (RB10): label and legend travel resolved
 * from ms-application.
 */
const ValidityFrame = ({ validity }: { validity: ValidityData }) => {
  const { clientTheme } = useClientTheme();
  return (
    <Card width='100%'>
      <Card
        variant={clientTheme ? 'primary' : 'success'}
        modifier='weak'
        spacing={'2'}
      >
        <H
          type='3'
          variant='neutral-1'
          withMargin={false}
          weight='bold'
          modifier='strong'
        >
          Vigencia
        </H>
      </Card>
      <Card display='flex' alignItems='center' gap='48px' margin={{ top: '3' }}>
        <Card display='flex' alignItems='center' gap='10px'>
          <Span type='2' variant='neutral' modifier='strong'>
            Fecha inicio:
          </Span>
          <Span type='2' variant='neutral'>
            {formatDate(validity.start_date)}
          </Span>
        </Card>
        <Card display='flex' alignItems='center' gap='10px'>
          <Span type='2' variant='neutral' modifier='strong'>
            Fecha fin:
          </Span>
          <Span type='2' variant='neutral'>
            {formatDate(validity.end_date)}
          </Span>
        </Card>
        <Badge type='text' variant={LABEL_BADGE_VARIANT[validity.label]} size='md'>
          <Span type='3' variant={LABEL_TEXT_VARIANT[validity.label]} modifier='strong'>
            {LABEL_TEXT[validity.label]}
          </Span>
        </Badge>
        {validity.legend && (
          <Span type='5' variant='neutral'>
            {validity.legend}
          </Span>
        )}
      </Card>
    </Card>
  );
};

export default ValidityFrame;
